<template>
  <div class="coupon-index">
    <div class="topbar">
      <div class="top-title"></div>
      <div class="top-action"></div>
    </div>

    <div class="banner">
      <div class="banner-action" @click="$router.push({ name: 'couponClaimed' })">
        <van-icon name="records" />
        <span>已领取</span>
      </div>
      <div class="banner-content">
        <div class="banner-title">众连权益.Benefits Platform</div>
        <div class="banner-subtitle">2026 运营商专属数字化权益平台</div>
      </div>
    </div>

    <van-tabs v-model="active" swipeable sticky animated @change="onTabChange" class="tabs">
      <van-tab v-for="c in categories" :title="c.name" :key="c.id">
        <div class="list">
          <van-skeleton v-if="loading" title :row="3" class="sk" />

          <van-empty v-else-if="!coupons || coupons.length === 0" description="暂无可领取券" />

          <div v-else class="items">
            <div class="item" v-for="it in coupons" :key="it.id" @click="goDetail(it)">
              <div class="left">
                <img class="logo" :src="it.icon" />
                <div class="info">
                  <div class="name">{{ it.name }}</div>
                  <div class="cond">{{ it.condition }}</div>
                </div>
              </div>
              <div class="right">
                <div class="price"><span class="currency">¥</span>{{ it.amount }}</div>
              </div>
              <div class="claim-col">
                <van-button class="btn-claim" size="small" @click.stop="goDetail(it)">领取</van-button>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { getCouponCategories, getCouponsByCategory } from '@/api/coupon'
import { Toast } from 'vant'
export default {
  name: 'couponIndex',
  data() {
    return {
      active: 0,
      categories: [],
      coupons: [],
      loading: false
    }
  },
  async mounted() {
    await this.loadCategories()
    await this.loadCoupons()
  },
  methods: {
    async loadCategories() {
      try {
        const { data } = await getCouponCategories()
        this.categories = data || []
      } catch (e) {
        Toast.fail('加载分类失败')
      }
    },
    async loadCoupons() {
      const cat = this.categories[this.active]
      if (!cat) return
      this.loading = true
      try {
        const { data } = await getCouponsByCategory({ categoryId: cat.id })
        this.coupons = data || []
      } catch (e) {
        Toast.fail('加载券列表失败')
      } finally {
        this.loading = false
      }
    },
    onTabChange() {
      this.loadCoupons()
    },
    goDetail(it) {
      this.$router.push({
        name: 'couponDetail',
        params: { id: it.id }
      })
    },
  }
}
</script>
<style scoped lang="less">
.coupon-index {
  min-height: 100vh;
  background: #f7f7f8;
  padding-bottom: calc(1rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  box-sizing: border-box;
}
.topbar {
  height: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.6rem;
  box-sizing: border-box;
  border-bottom: none;
  position: sticky;
  top: 0;
  z-index: 10;
  background: transparent;
}
.top-title {
  font-size: 0.44rem;
  font-weight: 800;
  color: #222;
}
.top-action {
  font-size: 0.34rem;
  color: #9b1b1b;
  font-weight: 700;
}
.banner {
  position: relative;
  padding: 1.8rem 0.6rem 1.05rem;
  background: linear-gradient(135deg, #f0a79c 0%, #f4b6ac 45%, #f7c7bf 100%);
  border-bottom: 1px solid #b66c63;
  overflow: hidden;
}
.banner::before,
.banner::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(155, 27, 27, 0.36);
}
.banner::before {
  width: 4.2rem;
  height: 4.2rem;
  top: -2.6rem;
  left: -1.5rem;
}
.banner::after {
  width: 3.6rem;
  height: 3.6rem;
  top: -2.4rem;
  right: -1.4rem;
}
.banner-content {
  position: relative;
  z-index: 1;
  color: #1f2a37;
}
.banner-action {
  position: absolute;
  right: 0.6rem;
  bottom: 0.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.12rem;
  padding: 0.12rem 0.24rem;
  border-radius: 0.4rem;
  background: #ffffff;
  color: #9b1b1b;
  font-size: 0.28rem;
  font-weight: 600;
  box-shadow: 0 0.12rem 0.2rem rgba(155, 27, 27, 0.24);
}
.banner-action :deep(.van-icon) {
  font-size: 0.34rem;
}
.banner-title {
  font-size: 0.52rem;
  font-weight: 800;
  letter-spacing: 0.01rem;
}
.banner-subtitle {
  margin-top: 0.16rem;
  font-size: 0.3rem;
  color: #6b7280;
}
.tabs :deep(.van-tabs__wrap) {
  border-bottom: 1px solid #f3f3f3;
  background: #fff;
}
.tabs :deep(.van-tabs__nav) {
  padding: 0 0.4rem 0.12rem;
  background: #fff;
}
.tabs :deep(.van-tab) {
  font-weight: 600;
  color: #6b7280;
  padding: 0.24rem 0.28rem;
}
.tabs :deep(.van-tab--active) {
  color: #9b1b1b;
}
.tabs :deep(.van-tabs__line) {
  bottom: 0.14rem;
  height: 0.06rem;
  border-radius: 0.06rem;
  background: #9b1b1b;
}
.list {
  padding: 0.3rem 0.6rem 0.8rem;
  box-sizing: border-box;
}
.sk {
  background: #fff;
  border-radius: 0.16rem;
  padding: 0.5rem;
}
.items {
  display: flex;
  flex-direction: column;
  gap: 0.24rem;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.42rem 0.34rem;
  background: #fff;
  border-radius: 0.3rem;
  box-shadow: 0 0.12rem 0.22rem rgba(17, 24, 39, 0.06);
  border: 1px solid #eef1f6;
}
.left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}
.logo {
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 0.22rem;
  background: #f4b6ac;
}
.info {
  margin-left: 0.3rem;
  min-width: 0;
}
.name {
  font-size: 0.42rem;
  color: #333;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 4.7rem;
}
.cond {
  margin-top: 0.08rem;
  font-size: 0.32rem;
  color: #8a8a8a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 4.9rem;
}
.right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.18rem;
  flex-shrink: 0;
  margin-right: 0.22rem;
}
.price {
  font-size: 0.48rem;
  color: #1f2937;
  font-weight: 800;
  line-height: 1;
}
.currency {
  font-size: 0.3rem;
  margin-right: 0.04rem;
  font-weight: 700;
}
.claim-col {
  width: 1.6rem;
  display: flex;
  align-items: stretch;
}
.btn-claim {
  width: 100%;
  height: 100%;
  min-height: 1.5rem;
  border-radius: 0.2rem;
  background: #9b1b1b;
  border: none;
  color: #fff;
  font-weight: 700;
  box-shadow: 0 0.12rem 0.2rem rgba(155, 27, 27, 0.34);
}
.btn-claim:active {
  opacity: 0.92;
}
</style>
